module.exports = __webpack_public_path__ + "static/media/04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_16.845b6d33.jpg";